import { Provider, Type } from '@angular/core';
import { AssetImagesProviderService } from '../providers/asset-images-provider.service';

export const provideAssetImages = (
  provider: Type<AssetImagesProviderService>,
): Provider => ({
  provide: AssetImagesProviderService,
  useClass: provider,
});
